import React from 'react';
import { MadadLandingPage } from 'screens/MadadPage/landing/MadadLandingPage';
import Navigation from 'components/navigation';
import { noop } from 'lodash';
import { HeaderWrapper } from 'ds/components/Layout';
import { useIntersectionObserver } from 'hooks/useIntersectionObserver';
import { HEADER_HEIGHT, LOGO_SIZE, ScrollSpaceReservator } from '../subheader/styled';
import { MadadSubheader } from '../subheader/MadadSubheader';

const subheaderMargin = HEADER_HEIGHT + LOGO_SIZE;

const MadadPage: React.FC = () => {
  const heroRef = React.useRef<HTMLDivElement>(null);
  const [ isSubheaderVisible, setIsSubheaderVisible ] = React.useState(true);

  useIntersectionObserver(([ entry ]) => {
    setIsSubheaderVisible(entry.isIntersecting);
  }, [ heroRef ], { rootMargin: `-${subheaderMargin}px 0px 0px 0px` });

  return (
    <>
      <HeaderWrapper isFixedMode>
        <Navigation
          isMobileMapViewActive={false}
          setMobileMapViewActive={noop}
        />
        <MadadSubheader isVisible={isSubheaderVisible} />
      </HeaderWrapper>
      <ScrollSpaceReservator />
      <MadadLandingPage heroRef={heroRef} />
    </>
  );
};

export default MadadPage;
